import React from 'react'

import ProjectTree_Item from "./components/item"
import ProjectSession from "../../../../model2/project/project-session"
import ProjectTree_MultiItem from "./components/item-multi"
import ErrorBoundary from "../../../../error-boundary"
import {CheckboxType} from "../../../../gd-components/checkbox/checkbox"
import {SelectParent_SectionType} from "../../@const"
import {SpaceProto} from "../../../../model2/space/space-proto"
import Workspace from "../../../../model2/space/workspaces/workspace"
import ProjectTree_ProjectsSection from "./components/projects-root"
import {SpaceProjects} from "../../../../model2/space/system/projects"
import {EntityType} from "../../../../gd/const/item";
import ProjectSessionCollection from "../../../../model2/project/collection"
import {ProjectsTreeSortType} from "../../../../model2/space/@types"
import {ItemDisplay} from "../../../../model2/item/@type";

type Props = {

    // parentSelector          : SelectParentNew | SelectParentsNew | MoveToFolderMain | ProjectFinderMain | ProjectFinder | ModalMoveTo_ProjectsTree
    parentSelector          : ITreeSelectorParent
    rootProjects            : ProjectSession[]
    section                 : SelectParent_SectionType | SpaceProto
    sortType                : ProjectsTreeSortType

    applyTreeDisplay?       : boolean
    colorized?              : boolean
    initialRootExpanded?    : boolean

    onSelect                : callback
    onToggleExpand          :    callback
}

type State = {
    isRootExpanded: boolean
}

export interface ITreeSelectorParent {
    multiselect             : boolean                                   // specifies if we select one item or many
    selectedProjects        : ID[]                                      // currently selected projects ?
    value?                  : ID | null                                 // current projectId (used in single select only)
    highlightedProjectId?   : ID                                        // project the keyboard cursor is on (single select only)

    /**
     * Specifies the entity types for which available parent options should be shown.
     * Accepts a single EntityType or an array of EntityTypes (logical OR).
     */
    parentsFor              : EntityType | EntityType[] | undefined             // specifies which entity we use this tree for

    onNewProjectClick?      : func                                              // callback on new project button click
    hidePopover?            : func                                              // callback to hide popover

    props                   : {

        inheritedChildrenSelection? : boolean                                               // ???
        multiselectCheckboxType?    : CheckboxType                                          // this is how checkbox looks like in multi select mode
        canBeNull?                  : boolean                                               // ???
        displayWorkspaceRoot?       : boolean                                               // if true shows workspace itself ???
        hideStarred?                : boolean                                               // hide starred block
        hidePinned?                 : boolean                                               // hide pinned block
        hideEmptySections?          : boolean                                               // hide menu section if it has no items
        availableProjects?          : ProjectSessionCollection                              // projects available for selection (will be shown)
        getAvailableProjects?       : {(): Promise<ProjectSessionCollection | undefined>}   // callback to load of available projects triggered on popover show (is used instead of availableProjects if necessary)
        unselectLabel?              : string                                                // label for unselect option in menu
        unselectIcon?               : string                                                // icon for unselect option in menu
    }

}


// const debug = "ProjectTree_New"
const debug = false

export default class ProjectTree_New extends React.Component<Props, State> {

    static defaultProps = {
        sortType: ProjectsTreeSortType.ALPHABETICAL //ProjectsTreeSortType.MANUAL
    }

    private isMultiSelect               : boolean
    private inheritedChildrenSelection  : boolean   // if parent selected - > select all children

    constructor(props: Props) {
        super(props)

        this.isMultiSelect              = this.props.parentSelector.multiselect
        this.inheritedChildrenSelection = !!this.props.parentSelector.props.inheritedChildrenSelection

        this.state = {
            isRootExpanded: _.get(props, 'initialRootExpanded', true)
        }
    }

    onToggleRootExpand = (value?: boolean) => {
        this.setState({
            isRootExpanded: !_.isNil(value) ? value : !this.state.isRootExpanded
        })
    }

    renderListItems(level: number, children: ProjectSession[], projectTree: JSX.Element[], isParentSelected?: boolean) {
        let projects : ProjectSession[] = children

        debug && console.log(debug, 'renderListItems', level, projects, this.props.parentSelector.parentsFor)

        // We need to filter out projects we shoud not display based on ParentsForType
        // and tree display when needed
        switch (this.props.parentSelector.parentsFor) {
            // as of right now I think nobody needs views as they have no children
            default:

                let filterFunction : func

                if (this.props.applyTreeDisplay) {
                    filterFunction = (project:ProjectSession)=>{
                        return (project.treeDisplay === ItemDisplay.VISIBLE || project.treeDisplay === ItemDisplay.GHOST_VISIBLE)
                            && !project.isView && !project.isTag
                    }
                } else {
                    filterFunction = (project:ProjectSession)=>{
                        return !project.isView && !project.isTag
                    }
                }

                projects = _.filter(projects, filterFunction) as ProjectSession[]
                break
        }
        // End Filter

        // Sort projects
        switch (this.props.sortType) {
            case ProjectsTreeSortType.ALPHABETICAL  :
                projects        = _.orderBy(projects, (project: ProjectSession)=>project.name, 'asc')
                break

            case ProjectsTreeSortType.MANUAL_OLD       :
            default                                 :
                projects = _.orderBy(projects, [
                    (project) => {
                        const index = _.indexOf(gd.user.menu.projectsAll.sortedMap.root, project.id)
                        if (index === -1) return projects.length
                        return index
                    },
                    project => project.sortPosition,
                    project => project.name
                ], ['asc', 'asc', 'asc'])
                break
        }

        _.map(projects, (project: ProjectSession, key: number)=>{
            if (this.isMultiSelect) {
                projectTree.push(
                    <ProjectTree_MultiItem
                        key                         = {'{0}_{1}'.f(level, project.id)}
                        colorized                   = {this.props.colorized}
                        project                     = {project}
                        level                       = {level}
                        multiselectCheckboxType     = {this.props.parentSelector.props.multiselectCheckboxType}
                        inheritedChildrenSelection  = {this.inheritedChildrenSelection}
                        isParentSelected            = {isParentSelected}
                        selectedProjects            = {this.props.parentSelector.selectedProjects}
                        onSelect                    = {this.props.onSelect}
                        onMenuItemHandleClick       = {this.props.onToggleExpand}
                    />
                )
            } else {
                projectTree.push(
                    <ProjectTree_Item
                        key                     = {'{0}_{1}'.f(level, project.id)}
                        colorized               = {this.props.colorized}
                        project                 = {project}
                        level                   = {level}
                        selectedProjects        = {this.props.parentSelector.selectedProjects}
                        keyboardHighlighted     = {project.id === this.props.parentSelector.highlightedProjectId}
                        onSelect                = {this.props.onSelect}
                        onMenuItemHandleClick   = {this.props.onToggleExpand}
                    />
                )
            }

            debug && console.log(debug, 'renderListItems is expanded:', project.treeIsExpandedProjectSelector, !_.isEmpty(project.treeChildren), project.name)

            if (project.treeIsExpandedProjectSelector && !_.isEmpty(project.treeChildren)) {
                const isSelected = isParentSelected || this.props.parentSelector.selectedProjects.includes(project.id)
                this.renderListItems(level+1, project.treeChildren, projectTree, isSelected)
            }
        })
    }

    renderWithRoots(projectTree: JSX.Element[]) {

        if (this.props.section instanceof Workspace) {
            // render workspace as first level
            this.renderListItems(0, [(this.props.section as Workspace).project], projectTree)
        } else if (this.props.section instanceof SpaceProjects) {
            // add "Projects" system space as root for all root projects
            const canBeSelected = !this.isMultiSelect && !!this.props.parentSelector.props.canBeNull
            // !value - means nothing selected at all
            const isSelected = canBeSelected && !this.props.parentSelector.value
            projectTree.push(
                <ProjectTree_ProjectsSection
                    key                     = 'projects'
                    canBeSelected           = {canBeSelected}
                    isSelected              = {isSelected}
                    isExpanded              = {this.state.isRootExpanded}
                    onSelect                = {this.props.onSelect}
                    onMenuItemHandleClick   = {this.onToggleRootExpand}
                />
            )
            this.state.isRootExpanded && this.renderListItems(1, this.props.rootProjects, projectTree)
        } else {
            this.renderListItems(0, this.props.rootProjects, projectTree)
        }
    }

    render() {
        const projectTree: JSX.Element[] = []
        if (this.props.parentSelector.props.displayWorkspaceRoot) {
            this.renderWithRoots(projectTree)
        } else {
            this.renderListItems(0, this.props.rootProjects, projectTree)
        }

        return (
            <ErrorBoundary>
                {projectTree}
            </ErrorBoundary>
        )
    }
}
